import {useRouteParam} from "state/hooks";

export function useWorkspaceId() {
    return useRouteParam('id')[0];
}